import { render, staticRenderFns } from "./miniStat.vue?vue&type=template&id=03b693d2&scoped=true"
import script from "./miniStat.vue?vue&type=script&lang=js"
export * from "./miniStat.vue?vue&type=script&lang=js"
import style0 from "./miniStat.vue?vue&type=style&index=0&id=03b693d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b693d2",
  null
  
)

export default component.exports